import { render, staticRenderFns } from "./UKBasketClassic.vue?vue&type=template&id=22c45229&"
import script from "./UKBasketClassic.vue?vue&type=script&lang=js&"
export * from "./UKBasketClassic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports